
export default function( settings )
{
    settings.slot.background = 'res/games/game_45/screen.png';
    settings.slot.underScreen = 'res/games/game_45/under_screen.png';
    settings.slot.underScreenPos = {x: 66, y: 126};
    settings.slot.symbol_animation_filename_pattern = 'res/games/game_45/balls/%d/45_%d';

    settings.slot.balls = 'res/games/game_45/balls/{symbol}/45_{symbol}_%03d.png';

    settings.slot.a1_a15 = 'res/games/game_45/a1_a15.png'

    settings.slot.lines_pattern  = 'res/games/game_45/lines/line_%02d.png';
    settings.slot.lines_position = [
        [ 43, 406 ],
        [ 44, 213 ],
        [ 44, 601 ],
        [ 44, 148 ],
        [ 44, 208 ],
        [ 44, 340 ],
        [ 44, 171 ],
        [ 44, 277 ],
        [ 44, 274 ],
    ];

    settings.slot.left_billets_on_filename_pattern  = 'res/games/game_45/billets/pl%02d.png';
    settings.slot.right_billets_on_filename_pattern  = 'res/games/game_45/billets/pr%02d.png';
    settings.slot.left_billets_coords = [
        {x:4, y:384},
        {x:4, y:190},
        {x:4, y:579},
        {x:4, y:125},
        {x:4, y:644},
        {x:4, y:319},
        {x:4, y:449},
        {x:4, y:255},
        {x:4, y:514},
    ];
    settings.slot.right_billets_coords = [
        {x:1133, y:384},
        {x:1133, y:190},
        {x:1133, y:579},
        {x:1133, y:125},
        {x:1133, y:644},
        {x:1133, y:319},
        {x:1133, y:449},
        {x:1133, y:514},
        {x:1133, y:255},
    ];
    
    delete settings.slot.systemaTextColor
    settings.slot.terminalTextColor = 0xFFFFFF

    settings.table.background = 'res/games/game_45/table/background.png';
    settings.table.scatterPrice = {
        wins:[3,4,5],
        position:{x:1124, y:481}
    };

    settings.table.priceTable = [
        {
            symbol:0,
            wins:[2,3,4,5],
            position:{x:937, y:214}
        },
        {
            symbol:1,
            wins:[2,3,4,5],
            position:{x:1124, y:214}
        },
        {
            symbol:2,
            wins:[2,3,4,5],
            position:{x:937, y:287}
        },
        {
            symbol:3,
            wins:[2,3,4,5],
            position:{x:1124, y:287}
        },
        {
            symbol:4,
            wins:[3,4,5],
            position:{x:937, y:362}
        },
        {
            symbol:5,
            wins:[3,4,5],
            position:{x:1124, y:362}
        },
        {
            symbol:6,
            wins:[3,4,5],
            position:{x:937, y:421}
        },
        {
            symbol:7,
            wins:[3,4,5],
            position:{x:1124, y:421}
        },
        {
            symbol:8,
            wins:[3,4,5],
            position:{x:937, y:481}
        },
        // X2 symb: all price == 0
        // {
        //     symbol:9,
        //     wins:[3,4,5],
        //     position:{x:1124, y:481}
        // }
    ];

    settings.help.pages = 34
    settings.help.pageNameFormat = 'res/games/game_45/help/%02d.png'

    settings.texts.imgMain = 'res/games/game_45/game_text.png';
    settings.texts.imgRisk = 'res/games/game_45/risk_text.png';

    settings.ui.buttons.spin.frames.normal =          'res/games/game_45/ui/rezultat_on.png'
    settings.ui.buttons.spin.frames.disabled =        'res/games/game_45/ui/rezultat_off.png'
    settings.ui.buttons.collect.frames.normal =       'res/games/game_45/ui/rezultat_on.png'
    settings.ui.buttons.collect.frames.disabled =     'res/games/game_45/ui/rezultat_off.png'
    settings.ui.buttons.finish.frames.normal =        'res/games/game_45/ui/exit_pari_on.png';
    settings.ui.buttons.finish.frames.disabled =      'res/games/game_45/ui/exit_pari_off.png';
    settings.ui.buttons.end_pari.frames.normal =      'res/games/game_45/ui/exit_pari_on.png';
    settings.ui.buttons.end_pari.frames.disabled =    'res/games/game_45/ui/exit_pari_off.png';
    settings.ui.buttons.gamble.frames.normal =        'res/games/game_45/ui/auto_on.png';
    settings.ui.buttons.gamble.frames.disabled =      'res/games/game_45/ui/auto_off.png';
    settings.ui.buttons.risk_red.frames.normal =      'res/games/game_45/ui/red_on.png';
    settings.ui.buttons.risk_red.frames.disabled =    'res/games/game_45/ui/red_off.png';
    settings.ui.buttons.risk_black.frames.normal =    'res/games/game_45/ui/black_on.png';
    settings.ui.buttons.risk_black.frames.disabled =  'res/games/game_45/ui/black_off.png';

    settings.ui.buttons.autoplay.frames.normal =      'res/games/game_45/ui/auto_off.png';
    settings.ui.buttons.autoplay.frames.disabled =    'res/games/game_45/ui/auto_off.png';
    settings.ui.buttons.autoplayoff.frames.normal =   'res/games/game_45/ui/auto_on.png';
    settings.ui.buttons.autoplayoff.frames.disabled = 'res/games/game_45/ui/auto_on.png';
    settings.ui.buttons.menu.frames.normal =          'res/games/game_45/ui/menu_on.png';
    settings.ui.buttons.menu.frames.disabled =        'res/games/game_45/ui/menu_off.png';
    settings.ui.buttons.linebet.frames.normal =       'res/games/game_45/ui/size_step_on.png';
    settings.ui.buttons.linebet.frames.disabled =     'res/games/game_45/ui/size_step_off.png';
    settings.ui.buttons.visual_mode.frames.normal =   'res/games/game_45/ui/visual_mode_on.png';
    settings.ui.buttons.visual_mode.frames.disabled = 'res/games/game_45/ui/visual_mode_off.png';
    settings.ui.buttons.info.frames.normal =          'res/games/game_45/ui/info_on.png';
    settings.ui.buttons.info.frames.disabled =        'res/games/game_45/ui/info_off.png';
    settings.ui.buttons.sound_on.frames.normal =      'res/games/game_45/ui/sound_on.png'
    settings.ui.buttons.sound_off.frames.normal =     'res/games/game_45/ui/sound_off.png'

    settings.ui.buttons.next.frames.normal =          'res/games/game_45/ui/help_next_on.png'
    settings.ui.buttons.next.frames.disabled =        'res/games/game_45/ui/help_next_off.png'
    settings.ui.buttons.back.frames.normal =          'res/games/game_45/ui/help_prev_on.png'
    settings.ui.buttons.back.frames.disabled =        'res/games/game_45/ui/help_prev_off.png'
    settings.ui.buttons.exit.frames.normal =          'res/games/game_45/ui/help_back_on.png'
    settings.ui.buttons.exit.frames.disabled =        'res/games/game_45/ui/help_back_off.png'

    settings.ui.buttons.spin.position =
        settings.ui.buttons.collect.position =     { x : 1448, y : 761 }
    settings.ui.buttons.autoplay.position =
        settings.ui.buttons.autoplayoff.position = { x : 1320, y : 761 }
    settings.ui.buttons.info.position =            { x : 1052, y : 7   }
    settings.ui.buttons.sound_on.position =
        settings.ui.buttons.sound_off.position =   { x : 1112, y : 62  }
    settings.ui.buttons.visual_mode.position =     { x : 0,    y : 702 }
    settings.ui.buttons.finish.position =
        settings.ui.buttons.end_pari.position =    { x : 9,    y : 2   }
    settings.ui.buttons.menu.position =            { x : 1192, y : 761 }
    settings.ui.buttons.linebet.position =         { x : 1192, y : 825 }
    settings.ui.buttons.risk_red.position =        { x : 1192, y : 761 }
    settings.ui.buttons.risk_black.position =      { x : 1192, y : 825 }
    settings.ui.buttons.next.position =            { x : 793,  y : 814 }
    settings.ui.buttons.back.position =            { x : 662,  y : 814 }
    settings.ui.buttons.exit.position =            { x : 23,   y : 814 }

    settings.smallTicket.balls_screen = 'res/games/game_45/small_ticket/balls_screen.png'
    settings.smallTicket.risk_template = 'res/games/game_45/small_ticket/risk_screen%02d.png'
    settings.smallTicket.lines_choice = 'res/games/game_45/small_ticket/sat_%02d.png'

    settings.risk.background = 'res/games/game_45/risk/risk_screen.png'
    settings.risk.redButton.state.normal =
        settings.risk.redButton.state.over =
        settings.risk.redButton.state.pressed =
        settings.risk.redButton.state.disabled = 'res/games/game_45/risk/red_button.png'
    settings.risk.blackButton.state.normal =
        settings.risk.blackButton.state.over =
        settings.risk.blackButton.state.pressed =
        settings.risk.blackButton.state.disabled = 'res/games/game_45/risk/blue_button.png'
    settings.risk.history.cardOffset = 94
    settings.risk.currentWinLabel.font =
        settings.risk.nextWinLabel.font = 'game_45__digits_risk_win'
    settings.risk.currentWinLabel.position = { x : 120, y : 243 }
    settings.risk.nextWinLabel.position = { x : 1079, y : 243 }
    settings.risk.currentStepLabel.font =
        settings.risk.stepsLabel.font = 'game_45__digits_risk_steps'
    settings.risk.redButton.position = { x : 140, y : 426 }
    settings.risk.blackButton.position = { x : 797, y : 426 }

    settings.risk.check = 'res/games/game_45/risk/cheque.png'
    settings.risk.table_background = 'res/games/game_45/risk/table.png'
    settings.risk.light_plates.name = 'res/games/game_45/risk/light.png'

    return {
        //settings можно смело модифицировать - он копируется для каждой игры из шаблона:
        settings,

        //name для удобства чтения логов на сервере:
        name : 'game_45',
        //идентификатор математики на сервере:
        id : 581,

        reactive,

        graphics : [
            
            'res/games/game_45/a1_a15.png',

            //small ticket:
            'res/games/game_45/small_ticket/balls_screen.png',
            'res/games/game_45/small_ticket/risk_screen00.png',
            'res/games/game_45/small_ticket/risk_screen01.png',
            'res/games/game_45/small_ticket/sat_01.png',
            'res/games/game_45/small_ticket/sat_02.png',
            'res/games/game_45/small_ticket/sat_03.png',
            'res/games/game_45/small_ticket/sat_04.png',
            'res/games/game_45/small_ticket/sat_05.png',

            //help:
            'res/games/game_45/help/00.png',
            'res/games/game_45/help/01.png',
            'res/games/game_45/help/02.png',
            'res/games/game_45/help/03.png',
            'res/games/game_45/help/04.png',
            'res/games/game_45/help/05.png',
            'res/games/game_45/help/06.png',
            'res/games/game_45/help/07.png',
            'res/games/game_45/help/08.png',
            'res/games/game_45/help/09.png',
            'res/games/game_45/help/10.png',
            'res/games/game_45/help/11.png',
            'res/games/game_45/help/12.png',
            'res/games/game_45/help/13.png',
            'res/games/game_45/help/14.png',
            'res/games/game_45/help/15.png',
            'res/games/game_45/help/16.png',
            'res/games/game_45/help/17.png',
            'res/games/game_45/help/18.png',
            'res/games/game_45/help/19.png',
            'res/games/game_45/help/20.png',
            'res/games/game_45/help/21.png',
            'res/games/game_45/help/22.png',
            'res/games/game_45/help/23.png',
            'res/games/game_45/help/24.png',
            'res/games/game_45/help/25.png',
            'res/games/game_45/help/26.png',
            'res/games/game_45/help/27.png',
            'res/games/game_45/help/28.png',
            'res/games/game_45/help/29.png',
            'res/games/game_45/help/30.png',
            'res/games/game_45/help/31.png',
            'res/games/game_45/help/32.png',
            'res/games/game_45/help/33.png',

            //risk:
            'res/games/game_45/risk/risk_screen.png',
            'res/games/game_45/risk/blue_button.png',
            'res/games/game_45/risk/red_button.png',
            'res/games/game_45/risk/cheque.png',
            'res/games/game_45/risk/table.png',
            'res/games/game_45/risk/light.png',
            'res/games/game_45/risk/game_45__digits_risk_steps.xml',
            'res/games/game_45/risk/game_45__digits_risk_win.xml',

            //table:
            'res/games/game_45/table/background.png',

            //ui:
            'res/games/game_45/ui/auto_off.png',
            'res/games/game_45/ui/auto_on.png',
            'res/games/game_45/ui/black_off.png',
            'res/games/game_45/ui/black_on.png',
            'res/games/game_45/ui/exit_pari_off.png',
            'res/games/game_45/ui/exit_pari_on.png',
            'res/games/game_45/ui/help_back_off.png',
            'res/games/game_45/ui/help_back_on.png',
            'res/games/game_45/ui/help_bell_off.png',
            'res/games/game_45/ui/help_bell_on.png',
            'res/games/game_45/ui/help_next_off.png',
            'res/games/game_45/ui/help_next_on.png',
            'res/games/game_45/ui/help_prev_off.png',
            'res/games/game_45/ui/help_prev_on.png',
            'res/games/game_45/ui/info_off.png',
            'res/games/game_45/ui/info_on.png',
            'res/games/game_45/ui/menu_off.png',
            'res/games/game_45/ui/menu_on.png',
            'res/games/game_45/ui/nota_off.png',
            'res/games/game_45/ui/nota_on.png',
            'res/games/game_45/ui/red_off.png',
            'res/games/game_45/ui/red_on.png',
            'res/games/game_45/ui/rezultat_off.png',
            'res/games/game_45/ui/rezultat_on.png',
            'res/games/game_45/ui/size_step_off.png',
            'res/games/game_45/ui/size_step_on.png',
            'res/games/game_45/ui/sound_off.png',
            'res/games/game_45/ui/sound_on.png',
            'res/games/game_45/ui/visual_mode_off.png',
            'res/games/game_45/ui/visual_mode_on.png',

            'res/games/game_45/screen.png',
            'res/games/game_45/under_screen.png',
            'res/games/game_45/game_text.png',
            'res/games/game_45/risk_text.png',

            'res/games/game_45/billets/pl00.png',
            'res/games/game_45/billets/pl01.png',
            'res/games/game_45/billets/pl02.png',
            'res/games/game_45/billets/pl03.png',
            'res/games/game_45/billets/pl04.png',
            'res/games/game_45/billets/pl05.png',
            'res/games/game_45/billets/pl06.png',
            'res/games/game_45/billets/pl07.png',
            'res/games/game_45/billets/pl08.png',

            'res/games/game_45/billets/pr00.png',
            'res/games/game_45/billets/pr01.png',
            'res/games/game_45/billets/pr02.png',
            'res/games/game_45/billets/pr03.png',
            'res/games/game_45/billets/pr04.png',
            'res/games/game_45/billets/pr05.png',
            'res/games/game_45/billets/pr06.png',
            'res/games/game_45/billets/pr07.png',
            'res/games/game_45/billets/pr08.png',

            'res/games/game_45/lines/line_00.png',
            'res/games/game_45/lines/line_01.png',
            'res/games/game_45/lines/line_02.png',
            'res/games/game_45/lines/line_03.png',
            'res/games/game_45/lines/line_04.png',
            'res/games/game_45/lines/line_05.png',
            'res/games/game_45/lines/line_06.png',
            'res/games/game_45/lines/line_07.png',
            'res/games/game_45/lines/line_08.png',

            'res/games/game_45/balls/0/45_0_000.png',
            'res/games/game_45/balls/0/45_0_001.png',
            'res/games/game_45/balls/0/45_0_002.png',
            'res/games/game_45/balls/0/45_0_003.png',
            'res/games/game_45/balls/0/45_0_004.png',
            'res/games/game_45/balls/0/45_0_005.png',
            'res/games/game_45/balls/0/45_0_006.png',
            'res/games/game_45/balls/0/45_0_007.png',
            'res/games/game_45/balls/0/45_0_008.png',
            'res/games/game_45/balls/1/45_1_000.png',
            'res/games/game_45/balls/1/45_1_001.png',
            'res/games/game_45/balls/1/45_1_002.png',
            'res/games/game_45/balls/1/45_1_003.png',
            'res/games/game_45/balls/1/45_1_004.png',
            'res/games/game_45/balls/1/45_1_005.png',
            'res/games/game_45/balls/1/45_1_006.png',
            'res/games/game_45/balls/1/45_1_007.png',
            'res/games/game_45/balls/1/45_1_008.png',
            'res/games/game_45/balls/2/45_2_000.png',
            'res/games/game_45/balls/2/45_2_001.png',
            'res/games/game_45/balls/2/45_2_002.png',
            'res/games/game_45/balls/2/45_2_003.png',
            'res/games/game_45/balls/2/45_2_004.png',
            'res/games/game_45/balls/2/45_2_005.png',
            'res/games/game_45/balls/2/45_2_006.png',
            'res/games/game_45/balls/2/45_2_007.png',
            'res/games/game_45/balls/2/45_2_008.png',
            'res/games/game_45/balls/3/45_3_000.png',
            'res/games/game_45/balls/3/45_3_001.png',
            'res/games/game_45/balls/3/45_3_002.png',
            'res/games/game_45/balls/3/45_3_003.png',
            'res/games/game_45/balls/3/45_3_004.png',
            'res/games/game_45/balls/3/45_3_005.png',
            'res/games/game_45/balls/3/45_3_006.png',
            'res/games/game_45/balls/3/45_3_007.png',
            'res/games/game_45/balls/3/45_3_008.png',
            'res/games/game_45/balls/4/45_4_000.png',
            'res/games/game_45/balls/4/45_4_001.png',
            'res/games/game_45/balls/4/45_4_002.png',
            'res/games/game_45/balls/4/45_4_003.png',
            'res/games/game_45/balls/4/45_4_004.png',
            'res/games/game_45/balls/4/45_4_005.png',
            'res/games/game_45/balls/4/45_4_006.png',
            'res/games/game_45/balls/4/45_4_007.png',
            'res/games/game_45/balls/4/45_4_008.png',
            'res/games/game_45/balls/5/45_5_000.png',
            'res/games/game_45/balls/5/45_5_001.png',
            'res/games/game_45/balls/5/45_5_002.png',
            'res/games/game_45/balls/5/45_5_003.png',
            'res/games/game_45/balls/5/45_5_004.png',
            'res/games/game_45/balls/5/45_5_005.png',
            'res/games/game_45/balls/5/45_5_006.png',
            'res/games/game_45/balls/5/45_5_007.png',
            'res/games/game_45/balls/5/45_5_008.png',
            'res/games/game_45/balls/6/45_6_000.png',
            'res/games/game_45/balls/6/45_6_001.png',
            'res/games/game_45/balls/6/45_6_002.png',
            'res/games/game_45/balls/6/45_6_003.png',
            'res/games/game_45/balls/6/45_6_004.png',
            'res/games/game_45/balls/6/45_6_005.png',
            'res/games/game_45/balls/6/45_6_006.png',
            'res/games/game_45/balls/6/45_6_007.png',
            'res/games/game_45/balls/6/45_6_008.png',
            'res/games/game_45/balls/7/45_7_000.png',
            'res/games/game_45/balls/7/45_7_001.png',
            'res/games/game_45/balls/7/45_7_002.png',
            'res/games/game_45/balls/7/45_7_003.png',
            'res/games/game_45/balls/7/45_7_004.png',
            'res/games/game_45/balls/7/45_7_005.png',
            'res/games/game_45/balls/7/45_7_006.png',
            'res/games/game_45/balls/7/45_7_007.png',
            'res/games/game_45/balls/7/45_7_008.png',
            'res/games/game_45/balls/8/45_8_000.png',
            'res/games/game_45/balls/8/45_8_001.png',
            'res/games/game_45/balls/8/45_8_002.png',
            'res/games/game_45/balls/8/45_8_003.png',
            'res/games/game_45/balls/8/45_8_004.png',
            'res/games/game_45/balls/8/45_8_005.png',
            'res/games/game_45/balls/8/45_8_006.png',
            'res/games/game_45/balls/8/45_8_007.png',
            'res/games/game_45/balls/8/45_8_008.png',
            'res/games/game_45/balls/9/45_9_000.png',
            'res/games/game_45/balls/9/45_9_001.png',
            'res/games/game_45/balls/9/45_9_002.png',
            'res/games/game_45/balls/9/45_9_003.png',
            'res/games/game_45/balls/9/45_9_004.png',
            'res/games/game_45/balls/9/45_9_005.png',
            'res/games/game_45/balls/9/45_9_006.png',
            'res/games/game_45/balls/9/45_9_007.png',
            'res/games/game_45/balls/9/45_9_008.png',
            'res/games/game_45/balls/10/45_10_000.png',
            'res/games/game_45/balls/10/45_10_001.png',
            'res/games/game_45/balls/10/45_10_002.png',
            'res/games/game_45/balls/10/45_10_003.png',
            'res/games/game_45/balls/10/45_10_004.png',
            'res/games/game_45/balls/10/45_10_005.png',
            'res/games/game_45/balls/10/45_10_006.png',
            'res/games/game_45/balls/10/45_10_007.png',
            'res/games/game_45/balls/10/45_10_008.png',
        ],
        sounds : [],
    }
}

function reactive( { space, container } ) {
    //тут можно изменять space типа space.s( 'stream' ).alter() или добавлять что-то в container ...
}



// WEBPACK FOOTER //
// ./src/games/game_45.es6